<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
    </div>

    <div class="content_main">
      <div>{{ titleLabel }}</div>
      <input
        id="notification_title"
        class="detail_input_field margin_bottom"
        type="text"
        v-model="inputData.title"
      />

      <div>{{ messageLabel }}</div>
      <textarea
        id="notification_message"
        class="detail_input_field margin_bottom"
        v-model="inputData.message"
      ></textarea>

      <div class="flex margin_bottom">
        <div>
          <div>{{ startLabel }}</div>
          <datepicker
            placeholder="Select Date"
            :config="start_config"
            :locale="ja"
            id="start"
            @on-change="customFormatter"
            class="start_datepicker start_date_time"
            :value="inputData.startDateTime"
          >
          </datepicker>
        </div>
        <span style="margin: 20px 20px 10px 10px">～</span>
        <div>
          <div>{{ endLabel }}</div>
          <datepicker
            placeholder="Select Date"
            :config="end_config"
            :locale="ja"
            id="end"
            @on-change="customFormatter"
            class="end_datepicker end_date_time"
            :value="inputData.endDateTime"
          >
          </datepicker>
        </div>
      </div>

      <div>{{ tenantSelectLabel }}</div>
      <div class="flex margin_bottom_s">
        <input
          id="searchWord"
          class="detail_input_field tenant_searchbox"
          type="text"
          :placeholder="searchPlaceholder"
        />
        <input
          type="button"
          :value="searchButton"
          class="finish_button"
          @click="searchCorporations(0)"
        />
      </div>
      <div class="flex selec_bottom">
        <input
          type="checkbox"
          class="checkbox"
          v-model="this.$store.state.notifications.selectAllFlag"
          @click="selectAllAction"
        />
        <div>{{ selectAllLabel }}</div>
      </div>

      <div class="table_area">
        <table class="content_title" rules="rows">
          <tr class="items_table">
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                :checked="checked"
                :disabled="disabled"
                @click="allCheckedAction"
              />
            </th>
            <td class="table_contents">
              <label>{{ corporationNameLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantIdLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantNameLabel }}</label>
            </td>
          </tr>
        </table>

        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="tenant in corporations"
            :key="tenant.companyId"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="tenant.checked"
                :disabled="disabled"
                @click="checkedAction(tenant)"
              />
            </th>
            <td class="table_contents">
              <label>{{ tenant.corporationName }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenant.companyId }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenant.companyName }}</label>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom">
        <pagination
          v-model="page"
          :records="total"
          :per-page="pageSize"
          :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
          @paginate="setCorporations(page - 1)"
        >
        </pagination>
      </div>

      <div class="bottom_button_area">
        <input
          type="button"
          :value="cancelButton"
          class="cancel_button"
          @click="cancel"
        />
        <input
          type="button"
          :value="confirmButton"
          class="finish_button"
          @click="checkInput"
        />
      </div>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import datepicker from 'vue-flatpickr-component'
import japanese from 'flatpickr/dist/l10n/ja.js'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      title: 'お知らせ追加',
      titleLabel: 'タイトル',
      messageLabel: 'メッセージ',
      startLabel: '開始',
      endLabel: '終了',
      tenantSelectLabel: '配信テナント選択',
      searchPlaceholder: '法人名/テナントID/テナント名',
      searchButton: '検索',
      selectAllLabel:
        '全体通知 ※個別のチェックに関係なく全体に通知します。後から作成されたテナントにも通知されます。',
      corporationNameLabel: '法人名',
      tenantIdLabel: 'テナントID',
      tenantNameLabel: 'テナント名',
      cancelButton: 'キャンセル',
      confirmButton: '確認',
      failureWord: '',
      checked: false,
      disabled: false,
      showFailureModal: false,
      showloadingModal: false,
      ja: japanese,
      start_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date(),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      end_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date('2100-01-01T09:00:00'),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      searchWord: null,
      selectAll: false
    }
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.corporations.total
      ) {
        return this.$store.state.corporations.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.corporations.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.corporations.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    corporations() {
      let corporations = this.$store.state.corporations.corporations
      let selectedTenantList = this.$store.state.notifications
        .selectedTenantList
      for (var i = 0; i < corporations.length; i++) {
        if (
          selectedTenantList.some(
            selectedTenant =>
              selectedTenant.companyId === corporations[i].companyId
          )
        ) {
          corporations[i].checked = true
        }
      }
      return corporations
    },
    inputData() {
      return this.$store.state.notifications.addData
    }
  },
  components: {
    datepicker,
    completeModalWindow,
    Pagination,
    loadingModalWindow
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    await this.updateWindowHeight()
    this.setCorporations(0)
    if (this.$store.state.notifications.selectAllFlag === true) {
      this.selectAllAction()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    searchCorporations(pageNo) {
      this.searchWord = document.getElementById('searchWord').value
      this.setCorporations(pageNo)
    },
    async setCorporations(pageNo) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        await this.$store.dispatch('corporations/setCorporations', {
          pageNo: pageNo,
          searchWord: this.searchWord
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_140001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0045')
        this.showFailureModal = true
      }
      this.showloadingModal = false
      this.checked = false
    },
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes
    },
    async cancel(e) {
      this.$store.dispatch('notifications/clearAddData')
      this.$store.dispatch('notifications/clearSelectedTenantList')
      this.$router.push('/master/notification')
    },
    selectAllAction(e) {
      // 全体通知用チェック、リストのグレーアウト。
      this.disabled = !this.disabled
      for (let i = 0; i < this.corporations.length; i++) {
        this.corporations[i].disabled = this.disabled
      }
      this.$store.dispatch(
        'notifications/updateSelectedTenantList',
        this.corporations
      )
      if (!this.selectAll) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.$store.state.notifications.selectAllFlag = false
      this.checked = !this.checked
      for (let i = 0; i < this.corporations.length; i++) {
        this.corporations[i].checked = this.checked
      }
      this.$store.dispatch(
        'notifications/updateSelectedTenantList',
        this.corporations
      )
    },
    checkedAction(tenant) {
      tenant.checked = !tenant.checked
      this.$store.dispatch('notifications/updateSelectedTenantList', [tenant])
      this.$store.state.notifications.selectAllFlag = false
    },
    checkInput() {
      // フォーマットチェック
      let title = document.getElementById('notification_title').value
      let message = document.getElementById('notification_message').value
      let start = document.getElementById('start').value
      let end = document.getElementById('end').value
      let startDateTime = 0
      let endDateTime = 0
      let selectedTenantList = this.$store.state.notifications
        .selectedTenantList

      // 空チェック
      if (start === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670002
        let eventType = 9
        let reason = 'MSGCRD0097'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0097.name +
          this.sysErrorMsg.MSGCRD0097.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      if (end === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670002
        let eventType = 9
        let reason = 'MSGCRD0097'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0097.name +
          this.sysErrorMsg.MSGCRD0097.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      let startDate = new Date(start)
      startDateTime = startDate.getTime()
      let endDate = new Date(end)
      endDateTime = endDate.getTime()
      if (startDateTime > endDateTime) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670002
        let eventType = 9
        let reason = 'MSGCRD0097'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0097.name +
          this.sysErrorMsg.MSGCRD0097.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      if (title === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670002
        let reason = 'MSGCRD0098'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0098.name +
          this.sysErrorMsg.MSGCRD0098.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else if (message === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670002
        let reason = 'MSGCRD0099'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0099.name +
          this.sysErrorMsg.MSGCRD0099.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else if (selectedTenantList.length === 0 && !this.selectAll) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_670002
        let reason = 'MSGCRD0100'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0100.name +
          this.sysErrorMsg.MSGCRD0100.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else {
        this.$store.dispatch('notifications/inputAddUpdate', {
          name: 'title',
          value: title
        })
        this.$store.dispatch('notifications/inputAddUpdate', {
          name: 'message',
          value: message
        })
        this.$store.dispatch('notifications/inputAddUpdate', {
          name: 'startDateTime',
          value: startDateTime
        })
        this.$store.dispatch('notifications/inputAddUpdate', {
          name: 'endDateTime',
          value: endDateTime
        })
        this.$router.push('/master/notification/addConfirm')
        if (this.selectAll) {
          this.$store.state.notifications.selectAllFlag = true
        }
      }
    },
    close() {
      this.showFailureModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.start_datepicker,
.end_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
  width: calc(100% - 30px);
}
.bottom_button_area {
  display: flex;
  justify-content: end;
  margin: 100px 20px 20px 20px;
}
.control_bar {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
.content_title {
  background-color: #ddffff;
  width: 100%;
}
.content_main {
  height: calc(100% - 110px);
  position: relative;
  background-color: #fff;
  padding: 26px 32px;
  overflow-y: scroll;
}
.table_contents {
  table-layout: fixed;
  width: 30%;
}
.table_area {
  border: 1px solid #a6e3e0;
}
.bottom {
  height: 53px;
  width: 100%;
  border-top: none;
  background-color: #ddffff;
  position: sticky;
  bottom: auto;
}
#notification_message {
  height: 37px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/notification/notificationAdd.vue